import { render } from "./ClientsTransaction.vue?vue&type=template&id=77bf1305&ts=true"
import script from "./ClientsTransaction.vue?vue&type=script&lang=ts"
export * from "./ClientsTransaction.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__